/* eslint-disable @typescript-eslint/no-unused-vars */
import type { PlanAPIInterface } from './api-switcher'
import { client } from './client'
import { responseDataConverter } from './converters'
import { convertApiPlansToPlanArray } from './plan-converters'

export const PlanAPI: PlanAPIInterface = {
  listPlans: (signal) =>
    responseDataConverter(
      client.GET('/plans', { signal }),
      convertApiPlansToPlanArray
    ),

  downgradePlan: (plan_id) => {
    if (plan_id === 'free') {
      // Cancel subscription (downgrade to free)
      return client.POST('/me/subscription/cancel', {}).then(({ error, response }) =>
        error
          ? { error: { code: response.status, message: error.message || 'Failed to cancel subscription' }, response }
          : { response }
      )
    }
    // For non-free downgrades, use the subscription update endpoint
    // The caller should use BillingAPI.updateMySubscription instead
    return Promise.resolve({
      error: { code: 501, message: 'Use BillingAPI for non-free plan changes' },
      response: new Response('', { status: 501 })
    })
  },

  getUpgradePlanUrl: async (plan_id, signal) => {
    // Deprecated: use BillingAPI.createCheckoutSession with product_id and price_id instead
    return {
      error: { code: 501, message: 'Use BillingAPI.createCheckoutSession with product_id and price_id instead.' },
      response: new Response('', { status: 501 })
    }
  },

  getUpdateCreditCardUrl: () => {
    const return_url = `${window.location.origin}/plan/management?success=1`
    return responseDataConverter(
      client.POST('/billing/customer-portal-session', { body: { return_url } }),
      (data) => data.portal_url
    )
  },

  getCreditCard: async (signal) => {
    const response = await client.GET('/me/subscription', { signal })

    if (response.data?.subscription) {
      const paymentMethod = response.data.payment_method
      if (paymentMethod && paymentMethod.card) {
        // Format credit card info like the dummy API: "Vista - 1234"
        const brand = paymentMethod.card.brand.charAt(0).toUpperCase() + paymentMethod.card.brand.slice(1)
        const last4 = paymentMethod.card.last4
        return {
          data: `${brand} - ${last4}`,
          response: response.response
        }
      } else {
        // No payment method associated
        return {
          data: '',
          response: response.response
        }
      }
    } else if (response.response?.status === 404) {
      // No active subscription
      return {
        data: '',
        response: response.response
      }
    } else {
      return {
        error: response.error ? { code: response.response?.status || 500, message: response.error.message || 'Failed to get subscription' } : { code: 500, message: 'Unknown error' },
        response: response.response
      }
    }
  }
}
